import { trackAgent } from '@leprecoins/effector';
import { createEvent } from 'effector';

const setup = createEvent();

export const agent = Object.assign(trackAgent({ setup }), { setup });
